import { defineComponent as _defineComponent } from 'vue'
import { THGChangeHistoryItem } from '@/interfaces/thg/THGChangeHistoryItem';
    import { ref } from 'vue';
    import { formatDate } from '@/utils/misc';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGChangeHistory',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
        data: THGChangeHistoryItem[] | undefined;
    };

    

    const isOpen = ref<number>(0);

return { __sfc: true,props, isOpen, formatDate }
}

})